type ChipVariant = 'success' | 'info' | 'warn' | 'danger' | 'neutral'

interface StatusChipProps {
  label: string
  variant: ChipVariant
}

const StatusChip = ({ label, variant }: StatusChipProps) => (
  <span className={`chip chip-${variant}`}>{label}</span>
)

export default StatusChip
